import {
  SAVE_USER_INFO,
  SUBMITTED_PROFILE,
  PROFILE_SET,
  NEW_PROFILE_INVALIDATED,
  SUBMIT_PROFILE_UPDATE,
  STORE_UPDATED_PROFILE,
  OPEN_PROFILE_UPDATE_MODAL,
  CLOSE_PROFILE_UPDATE_MODAL, INVALIDATE_PROFILE_UPDATE,
} from '../actions/actionTypes';

export const user = (state, action) => {
  const initState = {
    isPending: true,
    isSetProfilePagePending: true,
    isSetProfilePending: false,
    validation: {
      isError: false,
      message: '',
    },
    update: {
      isPending: false,
      isError: false,
      message: '',
      isModalOpen: false,
    },
  };
  const { payload } = action;
  switch (action.type) {
    case SAVE_USER_INFO:
      return { ...state, ...payload.user, isPending: false };
    case SUBMITTED_PROFILE:
      return { ...state, isSetProfilePending: true };
    case PROFILE_SET:
      return { ...state, isSetProfilePending: false };
    case NEW_PROFILE_INVALIDATED:
      return {
        ...state,
        isSetProfilePending: false,
        validation: {
          isError: true,
          message: action.payload.message,
        },
      };
    case OPEN_PROFILE_UPDATE_MODAL:
    case CLOSE_PROFILE_UPDATE_MODAL:
      return {
        ...state,
        update: {
          ...state.update,
          isError: false,
          message: '',
          isModalOpen: action.type === OPEN_PROFILE_UPDATE_MODAL,
        },
      };
    case SUBMIT_PROFILE_UPDATE:
      return {
        ...state,
        update: {
          ...state.update,
          isPending: true,
        },
      };
    case STORE_UPDATED_PROFILE:
      return {
        ...state,
        ...action.payload.info,
        update: {
          isError: false,
          message: '',
          isPending: false,
          isModalOpen: false,
        },
      };
    case INVALIDATE_PROFILE_UPDATE:
      return {
        ...state,
        update: {
          isError: true,
          message: action.payload.errors[0].code,
          isPending: false,
          isModalOpen: true,
        },
      };
    default:
      return state || initState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/user.js